import React from 'react';
import './AboutOurPartners2.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGithub, faTwitter, faLinkedin } from '@fortawesome/free-brands-svg-icons';
import partner2 from '../../assest/partners/partner2.jpg';
import partner1 from '../../assest/products/cisco.jpg';
import partner3 from '../../assest/products/vmware.jpg';
import partner4 from '../../assest/partners/partner4.jpg';

const partners = [
  {
    name: "DELL",
    logo: "https://link-to-dell-logo.com",
    description:
      "Listen. Learn. Deliver. DELL is empowering their customers by responding to customer's need.",
    links: {
      github: "https://github.com/dell",
      twitter: "https://x.com/Dell",
      linkedin: "https://www.linkedin.com/company/delltechnologies",
    },
  },
];
const partners2 = [
  {
    name: "CISCO",
    logo: "https://link-to-cisco-logo.com",
    description:
      "Connecting the world. Cisco empowers organizations and individuals to securely connect to each other and to the cloud.",
    links: {
      github: "https://github.com/cisco",
      twitter: "https://x.com/Cisco",
      linkedin: "https://www.linkedin.com/company/cisco",
    },
  },
];
const partners3 = [
  {
    name: "VMWare",
    logo: "https://link-to-vmware-logo.com",
    description:
      "VMware is a global leader in cloud infrastructure and digital workspace technology. We help businesses to innovate and grow.",
    links: {
      github: "https://github.com/vmware",
      twitter: "https://x.com/VMware",
      linkedin: "https://www.linkedin.com/company/vmware",
    },
  },
];

const partners4 = [
  {
    name: "Veeam",
    logo: "https://link-to-dell-logo.com",
    description:
      "Veeam is the best backup solution for virtualization environment. Easy to backup and replication.",
    links: {
      github: "https://github.com/veeam",
      twitter: "https://x.com/veeam",
      linkedin: "https://www.linkedin.com/company/veeam-software",
    },
  },
];
 

const AboutOurPartners2 = () => {
  return (
    <div className="about-partners">
      <h1>Our Key Partner</h1>
      <p className="p-title">
        We believe that working closly with our partners can lead us to success.
        Here is our focus partner technology.
      </p>
      <div className="partner-cards">
        {partners.map((partner, index) => (
          <div key={index} className="partner-card">
            <img
              src={partner2}
              alt={`${partner.name} Logo`}
              className="partner-logo"
            />
            <h4 className="partner-name">{partner.name}</h4>
            <p className="partner-description">{partner.description}</p>
            <div className="social-icons">
              <a
                href={partner.links.github}
                target="_blank"
                rel="noopener noreferrer"
                className="icon"
              >
                <FontAwesomeIcon icon={faGithub} />
              </a>
              <a
                href={partner.links.twitter}
                target="_blank"
                rel="noopener noreferrer"
                className="icon"
              >
                <FontAwesomeIcon icon={faTwitter} />
              </a>
              <a
                href={partner.links.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="icon"
              >
                <FontAwesomeIcon icon={faLinkedin} />
              </a>
            </div>
          </div>
        ))}

        {partners2.map((partner, index) => (
          <div key={index} className="partner-card">
            <img
              src={partner1}
              alt={`${partner.name} Logo`}
              className="partner-logo"
            />
            <h4 className="partner-name">{partner.name}</h4>
            <p className="partner-description">{partner.description}</p>
            <div className="social-icons">
              <a
                href={partner.links.github}
                target="_blank"
                rel="noopener noreferrer"
                className="icon"
              >
                <FontAwesomeIcon icon={faGithub} />
              </a>
              <a
                href={partner.links.twitter}  
                target="_blank"
                rel="noopener noreferrer"
                className="icon"
              >
                <FontAwesomeIcon icon={faTwitter} />
              </a>
              <a
                href={partner.links.linkedin}  
                target="_blank"
                rel="noopener noreferrer"
                className="icon"
              >
                <FontAwesomeIcon icon={faLinkedin} />
              </a>
            </div>
          </div>
        ))}

        {partners3.map((partner, index) => (
          <div key={index} className="partner-card">
            <img
              src={partner3}
              alt={`${partner.name} Logo`}
              className="partner-logo"
            />
            <h4 className="partner-name">{partner.name}</h4>
            <p className="partner-description">{partner.description}</p>
            <div className="social-icons">
              <a
                href={partner.links.github}
                target="_blank"
                rel="noopener noreferrer"
                className="icon"
              >
                <FontAwesomeIcon icon={faGithub} />
              </a>
              <a
                href={partner.links.twitter}
                target="_blank"
                rel="noopener noreferrer"
                className="icon"
              >
                <FontAwesomeIcon icon={faTwitter} />
              </a>
              <a
                href={partner.links.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="icon"
              >
                <FontAwesomeIcon icon={faLinkedin} />
              </a>
            </div>
          </div>
        ))}

        {partners4.map((partner, index) => (
          <div key={index} className="partner-card">
            <img
              src={partner4}  
              alt={`${partner.name} Logo`}
              className="partner-logo"
            />
            <h4 className="partner-name">{partner.name}</h4>
            <p className="partner-description">{partner.description}</p>
            <div className="social-icons">
              <a
                href={partner.links.github} 
                target="_blank"
                rel="noopener noreferrer"
                className="icon"
              >
                <FontAwesomeIcon icon={faGithub} />
              </a>
              <a
                href={partner.links.twitter}  
                target="_blank"
                rel="noopener noreferrer"
                className="icon"
              >
                <FontAwesomeIcon icon={faTwitter} />
              </a>
              <a
                href={partner.links.linkedin}  
                target="_blank"
                rel="noopener noreferrer"
                className="icon"
              >
                <FontAwesomeIcon icon={faLinkedin} />
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AboutOurPartners2;
